export const STORE_CODE = '24orepro';